import React from 'react'
import { Hero } from '../components/WindEnergy/Hero'
import { HaveAQuerry } from '../components/WindEnergy/HaveAQuerry'

export const WindEnergy = () => {
  return (
    <>
    <Hero/>
    <HaveAQuerry/>
    </>
  )
}
